<template>
  <div class="details">
    <div v-for="(item, i) in props?.data" :key="i" class="detail">
      <div class="title">
        {{ item?.data?.title }}
      </div>
      <div
        class="content"
        v-if="item?.data?.content && item?.data?.content.length > 0"
        v-for="(item2, i2) in item?.data?.content"
        :key="i2"
      >
        <div
          class="desc"
          v-if="item2?.text"
          v-for="(text, index) in parseList(item2?.text)"
          :key="index"
        >
          · {{ text }}
        </div>

        <NuxtImg
          class="imgsBox-app"
          v-for="(img, i3) in item2?.files || []"
          :src="img.fileUrl"
          :alt="img.fileUrl"
          quality="70"
          loading="lazy"
        />

        <a-row
          v-if="item2?.fileImageType === 'one'"
          :gutter="[30, 0]"
          class="imgsBox"
          style="margin-top: 20px"
        >
          <a-col :span="24" v-for="(img, i3) in item2?.files || []" :key="i3">
            <NuxtImg
              class="img"
              :src="img.fileUrl"
              :alt="img.fileUrl"
              quality="70"
              loading="lazy"
            />
            <div class="bottomTitle">{{ img.bottomTitle }}</div></a-col
          >
        </a-row>
        <a-row
          v-if="item2?.fileImageType === 'two'"
          :gutter="[30, 0]"
          class="imgsBox"
        >
          <a-col :span="12" v-for="(img, i3) in item2?.files || []" :key="i3">
            <NuxtImg
              class="img2"
              :src="img.fileUrl"
              :alt="img.fileUrl"
              quality="70"
              loading="lazy"
            />
            <div class="bottomTitle">{{ img.bottomTitle }}</div></a-col
          >
        </a-row>
        <a-row
          v-if="item2?.fileImageType === 'three'"
          :gutter="[30, 0]"
          class="imgsBox"
        >
          <a-col :span="8" v-for="(img, i3) in item2?.files || []" :key="i3">
            <NuxtImg
              class="img3"
              :src="img.fileUrl"
              :alt="img.fileUrl"
              quality="70"
              loading="lazy"
            />
            <div class="bottomTitle">{{ img.bottomTitle }}</div></a-col
          >
        </a-row>

        <a-row
          v-if="item2?.fileImageType === 'more'"
          :gutter="[30, 0]"
          class="imgsBox imgsmore"
        >
          <swiper
            :slidesPerView="3"
            :spaceBetween="30"
            :freeMode="true"
            :modules="state.modules"
            :autoplay="{ delay: 3000, disableOnInteraction: false }"
            @swiper="(e) => onSwiper(e, item2?.swiperId)"
            @slideChange="onSlideChange"
            class="mySwiper"
          >
            <swiper-slide
              class="swiper-slide"
              v-for="(img, i3) in item2?.files || []"
              :key="i3"
              ><NuxtImg
                style="width: 100%"
                :src="img.fileUrl"
                :alt="img.fileUrl"
                quality="70"
                loading="lazy"
              />
              <div class="bottomTitle">{{ img.bottomTitle }}</div></swiper-slide
            >
            <img
              src="@/assets/imgs/product/swiperIcon.png"
              alt=""
              class="swiper-button-prev"
              @click="onPrev(item2?.swiperId)"
            />
            <img
              src="@/assets/imgs/product/swiperIcon.png"
              alt=""
              class="swiper-button-next"
              @click="onNext(item2?.swiperId)"
            />
          </swiper>
        </a-row>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.details {
  width: 100%;

  .detail {
    // border: 1px solid yellowgreen;
    .title {
      .fcf(28,#fff,600);
      margin-bottom: 32px;
    }
    .content {
      // border: 1px solid red;

      .desc {
        .fcf(24,#ccc);
        .lh(29);
      }
      .desc ~ .desc {
        margin-top: 20px;
      }

      .imgsBox-app {
        width: 100%;
        margin-top: 10px;
        display: none;
      }

      .imgsBox {
        margin-top: 20px;
        .img {
          width: 100%;
          border-radius: 10px;
          // height: 37.76vw;
          // max-height: 725px;
        }
        .img2 {
          width: 100%;
          border-radius: 10px;
          height: 21.875vw;
          max-height: 420px;
        }
        .img3 {
          width: 100%;
          border-radius: 10px;
          height: 16vw;
          max-height: 307.5px;
        }
      }
      .imgsmore {
        margin-left: 0 !important;
        margin-right: 0 !important;
      }
      .bottomTitle {
        .fcf(24,#888,);
        .lh(32);
        text-align: center;
        margin-top: 20px;
      }
    }
    .content + .content {
      margin-top: 50px;
    }
  }
  .detail:not(:first-child) {
    margin-top: 100px;
  }

  .mySwiper {
    .swiper-slide {
      // min-height: 300px;
      width: 100%;
      // background: #666666;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        border-radius: 10px;
        display: block;
        width: 100%;
        // height: 100%;
        height: 16.04vw;
        max-height: 307px;
        object-fit: cover;
      }
    }

    .swiper-button-prev,
    .swiper-button-next {
      width: 42px;
      height: 42px;
    }

    .swiper-button-prev {
      position: absolute;
      top: 42.2%;
      left: 23px;
      transform: translateY(-50%) rotate(180deg);
    }

    .swiper-button-next {
      position: absolute;
      top: 42.2%;
      right: 23px;
      transform: translateY(-50%);
    }
  }
}

@media (max-width: 1024px) {
  .mySwiper {
    display: none;
  }
  .imgsBox {
    display: none;
  }

  .details {
    .detail {
      .title {
        margin-bottom: 20px;
        .fcf(18,#fff);
      }
      .content {
        .desc {
          .fcf(14,#ccc);
          .lh(24);
        }
        .desc ~ .desc {
          margin-top: 8px;
        }
        .imgsBox-app {
          display: block;
        }
      }
    }
    .detail:not(:first-child) {
      margin-top: 30px;
    }
  }
}
</style>

<script setup>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";
// Import Swiper styles
import "swiper/css";
// import required modules
import { FreeMode, Navigation, Pagination } from "swiper/modules";

import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { reactive } from "vue";

const state = reactive({
  modules: [FreeMode, Navigation, Pagination],
});

const props = defineProps({
  data: {
    type: Array,
    requeired: true,
    default: () => [],
  },
});

const parseList = (str) => {
  return JSON.parse(str);
};

const swiperDom = ref(null);
const swiperRefs = reactive({
  ids: {},
});
const onSwiper = (swiper, swiperId) => {
  console.log("swiper :>> ", swiper, swiperId);
  swiperRefs.ids[swiperId] = swiper;
  // swiperDom.value = swiper;
};
const onSlideChange = (swiper) => {
  console.log("swiper", swiper.activeIndex);
};
const onPrev = (swiperId) => {
  console.log("swiperId :>> ", swiperId);
  console.log("swiperRefs.ids[swiperId] :>> ", swiperRefs.ids[swiperId]);
  swiperRefs.ids[swiperId].slidePrev();
};
const onNext = (swiperId) => {
  console.log("swiperId :>> ", swiperId);
  console.log("swiperRefs.ids[swiperId] :>> ", swiperRefs.ids[swiperId]);
  swiperRefs.ids[swiperId].slideNext();
};
</script>
